//Componentes generales
import React, { useState, useContext, useMemo } from "react";
import SearchInput from "../searchInput/SearchInput";
import RenderRow from "../renderRows/RRWarehouses";
import windowSizeContext from "../../context/windowSize/windowSizeContext";
import normalizeText from "../../utils/normalizeText";

//Estilos
import './WarehouseList.css';

/*
    Componente encargado de la vista de los depósitos disponibles.
    Donde warehousesWithSectors es la lista de depósitos con sus sectores anidados.
*/
function WarehouseList({ warehousesWithSectors = [] }) {

    const [filter, setFilter] = useState("");

    const wSizeContext = useContext(windowSizeContext);
    const { height } = wSizeContext;

    const handdlerSearchInput = (data) => {
        setFilter(data);
    };

    const filteredWarehouses = useMemo(
        () =>
            warehousesWithSectors.filter(w =>
                normalizeText(w.deposi).includes(normalizeText(filter)) ||
                normalizeText(w.descrp).includes(normalizeText(filter)) ||
                normalizeText(w.direcc).includes(normalizeText(filter))
            ),
        [warehousesWithSectors, filter]
    );

    return (
        <div>
            <div style={{ marginLeft: "-150px" }}>
                <SearchInput defaultValue={filter} buscar={handdlerSearchInput} />
            </div>
            <div className='warehousesListDiv' style={{ height: height - 200, overflowY: 'scroll' }}>
                {filteredWarehouses.length === 0 ? (
                    <p className="no-records-message">No hay registros para mostrar</p>
                ) : (
                    filteredWarehouses.map((w, index) => (
                        <RenderRow
                            key={index}
                            index={index}
                            style={{}}
                            warehousesWithSectors={warehousesWithSectors}
                            filter={filter}
                        />
                    ))
                )}
            </div>
        </div>
    );
}

export default WarehouseList;
